import {
    ResetAttributesComponent as SourceResetAttributesComponent,
} from 'SourceComponent/ResetAttributes/ResetAttributes.component';
import React from 'react';
import './ResetAttributes.override.style';
import CloseIcon from '@scandipwa/scandipwa/src/component/CloseIcon';
import { getQueryParam } from '@scandipwa/scandipwa/src/util/Url';

export class ResetAttributesComponent extends SourceResetAttributesComponent {
    renderSelectedOption(selectedOption) {
        const { toggleCustomFilter } = this.props;
        const { attribute_code, attribute_label, value_string } = selectedOption;
        const onRemove = () => toggleCustomFilter(attribute_code, value_string);

        return (
            <div className="ResetAttributes-AttributeValue" key={value_string}>
                <div
                    className="ResetAttributes-CloseIcon"
                    role="button"
                    tabIndex={0}
                    onKeyDown={onRemove}
                    onClick={onRemove}
                    aria-label={'Close'}
                >
                    <CloseIcon />
                </div>
                <div className="ResetAttributes-AttributeText">
                    <span className="ResetAttributes-AttributeLabel">{`${attribute_label}: `}</span>
                    <span className="ResetAttributes-AttributeOption">
                        {this.renderSelectedOptionLabel(selectedOption.label)}
                    </span>
                </div>
            </div>
        );
    }

    render() {
        let { filtersData = {} } = this.props;
        const queryfilter = getQueryParam("customFilters", window.location || '');

        if (queryfilter) {
            const queryfilterdata = queryfilter.split(";")
            const data = queryfilterdata.map((value) => {
                if (value.includes("total_carat_weight")) {
                    filtersData['Total Carat Weight'] = [{
                        attribute_label: "Total Carat Weight",
                        attribute_code: "total_carat_weight",
                        value_string: value.split(":")[1],
                        label: value.split(":")[1].replace(",", "_")
                    }]
                }
            });
        }

        if (!Object.keys(filtersData).length) {
            return null;
        }

        return (
            <>
                {/* {this.renderDesktopTitle()}
                {this.renderMobileTitle()} */}
                <div className="ResetAttributes">
                    {Object.entries(filtersData).map(
                        ([attrName, attrData]) => this.renderResetItem(attrName, attrData),
                    )}
                </div>
            </>
        );
    }
}

export default ResetAttributesComponent;
